import React, { useState, useEffect } from "react";
import { loadShoppingList, deleteShoppingListItem } from "./Fetching";
import { post } from "../../lib/Fetching";
import Link from "../Link";
import Button from "../Button";
import ShoppingListRegisterButtons from "./ShoppingListRegisterButtons";
import ClientSuiteModal from "../products/modals/ClientSuiteModal";
import ClientSpecificationModal from "../products/modals/ClientSpecificationModal";

export default function ShoppingList({ id, registerItems }) {
  const [shoppingList, setShoppingList] = useState(null);
  const [showSuite, setShowSuite] = useState(false);
  const [showSpec, setShowSpec] = useState(false);

  const hideModal = () => {
    if (showSpec) setShowSpec(false);
    if (showSuite) setShowSuite(false);
  };

  const fetchShoppingList = () =>
    loadShoppingList(id).then(json => {
      setShoppingList(json.shopping_list);
    });

  useEffect(() => {
    fetchShoppingList();
  }, []);

  const deleteItem = item =>
    deleteShoppingListItem({
      shoppingListId: id,
      shoppingListItemId: item.id
    }).then(fetchShoppingList);

  if (!shoppingList) return <div>Loading...</div>;

  return (
    <div>
      {showSuite && <ClientSuiteModal id={showSuite} onClose={hideModal} />}
      {showSpec && <ClientSpecificationModal id={showSpec} onClose={hideModal} />}
      <h4>{shoppingList.name}</h4>
      <p style={{ color: "#AAA" }}>Created at {shoppingList.created_at_f}</p>
      <div style={{ width: 200 }}>
        <ShoppingListRegisterButtons registerItems={registerItems} list={shoppingList} />
      </div>
      <table className="table table-condensed table-hover">
        <thead>
          <tr>
            <th>{I18n.t("product")}</th>
            <th>{I18n.t("client_suite")}</th>
            <th>{I18n.t("client_specification")}</th>
            <th>{I18n.t("sample_information_list")}</th>
          </tr>
        </thead>
        <tbody>
          {shoppingList.items.map(item => (
            <tr key={item.id}>
              <td>{item.product_name}</td>
              <td>
                <Link onClick={() => setShowSuite(item.client_suite_id)}>
                  {item.client_suite_name}
                </Link>
              </td>
              <td>
                {item.client_specification_id && (
                  <Link onClick={() => setShowSpec(item.client_specification_id)}>
                    {item.client_specification_name}
                  </Link>
                )}
              </td>
              <td>{item.sample_information_name}</td>
              <td>
                <Link onClick={() => deleteItem(item)}>
                  <i className="fa fa-trash" />
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
